import supabase from "./supabase";
import dayjs from "dayjs";

// Fetch events by country and optional city
export async function getEvents({ country, city } = {}) {
    let query = supabase.from("events").select("*");

    if (country) {
        query = query.eq("country", country);
    }

    // Only filter by city if it's defined and not empty
    if (city?.trim()) {
        query = query.eq("city", city);
    }

    const { data, error } = await query;

    if (error) {
        console.error("Error fetching events:", error.message);
        throw new Error("Error fetching events: " + error.message);
    }

    return data;
}

// Delete an event by ID
export async function deleteEvent(id) {
    const { data, error } = await supabase
        .from("events")
        .delete()
        .eq("id", id)
        .select();

    if (error) {
        console.error("Error deleting event:", error.message);
        throw new Error("Error deleting event: " + error.message);
    }

    return data || [];
}

export async function createEditEvent(newEvent, id) {
    try {
        let query = supabase.from("events");

        // Convert to UTC
        if (newEvent.startDatetime) {
            newEvent.startDatetime = dayjs(newEvent.startDatetime).utc().format();
        }

        if (!id) {
            const { data, error } = await query.insert([newEvent]);
            if (error) throw error;
            return data;
        } else {
            const { data, error } = await query.update(newEvent).eq("id", id).select().single();
            if (error) throw error;
            return data;
        }
    } catch (err) {
        console.error("Unexpected Error creating event:", err);
        throw err; // So React Query can catch this
    }
}
